var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTgFooter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35 35",
  width: "1em",
  height: "1em"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 17.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.11 16.458q6.505-3.176 8.675-4.187c4.13-1.925 4.99-2.26 5.549-2.27.123-.003.398.031.576.193.15.137.192.322.212.451.02.13.044.426.025.657-.224 2.635-1.193 9.03-1.686 11.982-.208 1.249-.619 1.668-1.016 1.709-.864.089-1.52-.64-2.357-1.255-1.309-.961-2.048-1.56-3.319-2.498-1.469-1.084-.517-1.68.32-2.654.22-.255 4.025-4.134 4.099-4.486.01-.044.018-.208-.07-.295-.086-.086-.214-.057-.307-.033q-.197.05-6.274 4.647-.891.684-1.614.667c-.53-.013-1.552-.336-2.312-.613-.931-.34-1.672-.518-1.607-1.095q.05-.45 1.106-.92"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 2.747,
  x2: 27.354,
  y1: -6.844,
  y2: -5.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC6CDB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#586DE4"
})))));
export default SvgTgFooter;